__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-third-party-manage-center-v2/').replace(/[/]{3,}/g, "/");